import { UseMutateFunction, useMutation, UseMutationOptions } from "@tanstack/react-query";
import { DeleteCardResponseDTO } from "../../../api/response.types";

import { savedShipmentService } from "../../../api/api";

type UseSeaDeleteCardMutationReturnType = {
  isCardDeleted: boolean | undefined;
  deleteCard: UseMutateFunction<DeleteCardResponseDTO, Error, number>;
  isCardDeleteSuccess: boolean;
  isCardDeleteError: boolean;
  isCardDeleting: boolean;
};

export const useSeaDeleteCardMutation = (
  mutationOptions?: UseMutationOptions<DeleteCardResponseDTO, Error, number>
): UseSeaDeleteCardMutationReturnType => {
  const { data, mutateAsync, isError, isSuccess, isPending } = useMutation<DeleteCardResponseDTO, Error, number>({
    mutationFn: savedShipmentService.deleteCard,
    ...mutationOptions,
  });

  return {
    isCardDeleted: data?.deleted,
    deleteCard: mutateAsync,
    isCardDeleteSuccess: isSuccess,
    isCardDeleteError: isError,
    isCardDeleting: isPending,
  };
};
